import Vue from 'vue';
import VueGates from 'vue-gates';

Vue.use(VueGates, {
    superRole: 'super admin',
    persistent: true,
});